import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const PositioningStatement = () => {
  return (
    <section className="py-16 sm:py-28 bg-background">
      <div className="container max-w-3xl px-5 sm:px-6 lg:px-8">
        <div className="teal-rule mx-auto mb-8 sm:mb-10" />

        <blockquote className="text-center">
          <p className="text-xl sm:text-3xl font-bold text-foreground leading-snug mb-5 sm:mb-6">
            Built for the speed of health marketing.
            <br className="hidden sm:block" />
            {" "}Backed by the rigour of the TGA, FSANZ, ACCC & AHPRA Codes.
          </p>
          <p className="text-text-body text-base sm:text-lg leading-relaxed mb-5 sm:mb-6 max-w-3xl mx-auto">
            CompliGUARD sits inside your marketing workflow — not outside it. Every review
            builds your audit trail. Every product you load makes the system smarter. And every
            regulatory update is handled before it becomes your problem.
          </p>
          <cite className="text-text-caption text-xs sm:text-sm italic not-italic block leading-relaxed">
            The regulators are actively cracking down on digital advertising. CompliGUARD gives your team the infrastructure to keep up — without slowing down.
          </cite>
        </blockquote>

        <div className="teal-rule mx-auto mt-8 sm:mt-10" />

        <div className="mt-10 sm:mt-12 flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center">
          <Button
            asChild
            className="h-11 sm:h-12 px-7 sm:px-8 text-sm sm:text-base font-semibold bg-primary text-primary-foreground hover:bg-accent-hover rounded-full"
          >
            <Link to="/signup">Get started</Link>
          </Button>
          <Button
            asChild
            variant="outline"
            className="h-11 sm:h-12 px-7 sm:px-8 text-sm sm:text-base font-semibold rounded-full border-border text-foreground hover:bg-background"
          >
            <Link to="/compliance-quiz">Take the 2-min compliance quiz</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default PositioningStatement;
